import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import TransactionServices from "../TransactionServices";

export default function YoutubeTemporaryBox(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }

    let [youtubeTemporaryTable, setYoutubeTemporaryTable] = useState<any[]>([]);
    const checkUploadYoutube = () => {
        var payload = { type: 'youtubeV10' }
        TransactionServices.checkUploadYoutube(payload).then((res) => {
            console.log(res)
            youtubeTemporaryTable = res
            setYoutubeTemporaryTable(res)
            console.log("youtube temporary table test button")
        })
    }

    let [youtubeRedTemporaryTable, setYoutubeRedTemporaryTable] = useState<any[]>([]);
    const checkUploadYoutubeRed = () => {
        var payload = { type: 'youtubeRedV10' }
        TransactionServices.checkUploadYoutubeRed(payload).then((res) => {
            console.log(res)
            youtubeRedTemporaryTable = res
            setYoutubeRedTemporaryTable(res)
        })
    }


    useEffect(() => {
        checkUploadYoutube()
        checkUploadYoutubeRed()
    }, [param.param])

     const onClose = () => {
        param.YoutubeTemporaryTableClose();
    }


    return (
        <div className="ws-6">
            <Modal open={param.param} onClose={onClose} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >

                <div className="row-fluid sortable">
                    <div className="box span12">
                        <div className="box-header-main">
                            <h2 className="ws-10 "> <i className="fa fa-table"></i> Youtube Temporary Table</h2>
                            <div className="toolbox pull-right">

                                <button title="Refresh Youtube Temporary Table" className="btn  icon-btn delete " ng-click="init()">
                                    <i className="icon-reload"></i>
                                </button>
                            </div>
                        </div>
                        <div className="box-content">
                            <div className="alert alert-info  " data-ng-show="youtube.length == 0">No records to display</div>
                            <div className="table-responsive">
                                <table className="table">
                                    <tbody>
                                        <tr data-ng-repeat="details in youtube" >
                                            <th className="text-right ">Total Count for Claim Summary</th>
                                            <td  >0</td>
                                        </tr><tr data-ng-repeat="details in youtube" >
                                            <th className="text-right ">Total Count for Video</th>
                                            <td  >0</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                </div>
                <div className="box-footer">
                    <button className="btn icon-btn delete btn-sm " onClick={onClose}><i className="fa fa-close"></i>Close </button>
                </div>
            </Modal>
        </div>
    )
}